var _rect, _rect2, _g, _rect3, _circle, _path;

var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};

var SvgExistingEmail = function SvgExistingEmail(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '35px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '35px' : _ref$height,
      originalSize = _ref.originalSize,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 72,
    viewBox: "0 0 94 72",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 60,
    x: 2,
    y: 11,
    fill: "#FAFAFA",
    rx: 5.166
  })), /*#__PURE__*/React.createElement("mask", {
    id: "existing-email_svg__a",
    width: 92,
    height: 60,
    x: 1,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 91.36,
    height: 59.638,
    x: 1.627,
    y: 11.104,
    fill: "#fff",
    rx: 5.166
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#existing-email_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E2F1",
    d: "m43.005 51.876-41.38-33.16-.951-5.71 93.263-.793-.952 6.186-40.182 33.39a7.749 7.749 0 0 1-9.798.087Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FEA09A",
    strokeLinejoin: "round",
    strokeWidth: 1.291,
    d: "M1.625 70.742C15.5 59.345 23.913 52.637 37.788 41.24m55.196 29.502C79.11 59.345 70.696 52.637 56.821 41.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    stroke: "#FEA09A",
    strokeLinejoin: "round",
    strokeWidth: 1.291,
    d: "M42.735 51.228 1.31 14.592V9.041h91.994v5.551L53.08 51.157a7.749 7.749 0 0 1-10.346.071Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.221,
    cy: 11.421,
    r: 10.151,
    fill: "#D0E2F1"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 60,
    x: 1.5,
    y: 11.5,
    stroke: "#FEA09A",
    rx: 5.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.954,
    cy: 10.151,
    r: 10.151,
    fill: "#FE5348"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "m75.084 6.027-.176 6.462h-1.65l-.18-6.462h2.006Zm-1 9.346c-.298 0-.553-.105-.767-.316a1.03 1.03 0 0 1-.315-.766 1.01 1.01 0 0 1 .315-.757c.214-.21.47-.315.767-.315.285 0 .536.105.752.315a1.034 1.034 0 0 1 .171 1.302 1.17 1.17 0 0 1-.392.393c-.162.096-.34.144-.531.144Z"
  })));
};

export { SvgExistingEmail as ReactComponent };
export default "/_next/static/media/existing-email.f84f1e76.svg";